import { Link } from "react-router-dom";
import StatusAvatar from "../../components/statusAvatar";
import { formatDate } from "../../utils/date";

/* ─── Types ──────────────────────────────────────────────────────────── */

export interface CouponsSummaryRecord {
  membershipId?:      string;
  userId?:            string;
  userName?:          string;
  userPhone?:         string;
  profile?:           string;
  branchId?:          string;
  branchName?:        string;
  planName?:          string;
  startDate?:         string;
  endDate?:           string;
  packageExpiry?:     string;
  totalSessions?:     number;
  usedSessions?:      number;
  remainingSessions?: number;
}

/* ─── Columns ────────────────────────────────────────────────────────── */

export const getCouponsSummaryColumns = () => [
  { title: 'Branch', dataIndex: 'branchName', key: 'branch',      width: 160, render: (v?: string) => v || '-' },
  {
    title:  'Name',
    dataIndex: 'userName',
    key:    'name',
    width:  160,
    render: (text: string, record: CouponsSummaryRecord) =>
      record.userId ? (
        <Link to={`/user-detail/${record.userId}/membership`} style={{ color: 'inherit', textDecoration: 'none' }}>
          {text || '-'}
        </Link>
      ) : (text || '-'),
  },
  { title: 'Mobile', dataIndex: 'userPhone',  key: 'phoneNumber', width: 140, render: (v?: string) => v || '-' },
  {
    title:  'Photo',
    dataIndex: 'profile',
    key:    'profile',
    width:  80,
    render: (v?: string, record?: CouponsSummaryRecord) => {
      const img = <StatusAvatar src={v} />;
      return record?.userId
        ? <Link to={`/user-detail/${record.userId}/membership`} style={{ cursor: 'pointer' }}>{img}</Link>
        : img;
    },
  },
  { title: 'Membership Plan Name', dataIndex: 'planName', key: 'planName', width: 180, render: (v?: string) => v || '-' },
  {
    title:  'Coupons (Used/Total)',
    key:    'coupons',
    width:  160,
    render: (_: unknown, r: CouponsSummaryRecord) => `${r.usedSessions ?? 0} / ${r.totalSessions ?? 0}`,
  },
  {
    title:  'Package Expiry',
    dataIndex: 'packageExpiry',
    key:    'packageExpiry',
    width:  140,
    render: (v?: string) => formatDate(v) || '-',
  },
];
